(function (root, factory) {
  var api = factory();
  if (root) root.SownShippingClock = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
}(typeof window === 'undefined' ? null : window, function () {
  'use strict';

  var TZ = 'America/New_York';
  var partsFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  var weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function finite(value) { return typeof value === 'number' && Number.isFinite(value); }
  function dateParts(ms) {
    var fields = partsFormatter.formatToParts(new Date(ms));
    var result = {};
    fields.forEach(function (part) { if (part.type !== 'literal') result[part.type] = part.value; });
    return result;
  }
  function isDateKey(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    var bits = value.split('-').map(Number);
    return bits[0] >= 2000 && bits[0] <= 2100 &&
      new Date(Date.UTC(bits[0], bits[1] - 1, bits[2])).toISOString().slice(0, 10) === value;
  }
  function localNoonMs(year, month, day) {
    var candidate = Date.UTC(year, month - 1, day, 12, 0, 0);
    var local = dateParts(candidate);
    var offset = Date.UTC(+local.year, +local.month - 1, +local.day, +local.hour, +local.minute, +local.second) - candidate;
    return candidate - offset;
  }
  function invalidWindow() { return { active: false, reason: 'invalid', remainingMs: 0, cutoffMs: NaN, dateKey: null }; }

  function getWindow(nowMs, closedDates) {
    if (!finite(nowMs) || nowMs < Date.UTC(2000, 0, 1) || nowMs >= Date.UTC(2101, 0, 1) || (closedDates !== undefined && !Array.isArray(closedDates))) return invalidWindow();
    var local = dateParts(nowMs);
    var dateKey = local.year + '-' + local.month + '-' + local.day;
    if (!isDateKey(dateKey) || (closedDates || []).some(function (date) { return !isDateKey(date); })) return invalidWindow();
    var cutoffMs = localNoonMs(+local.year, +local.month, +local.day);
    var weekday = weekdayNames.indexOf(local.weekday);
    var holiday = (closedDates || []).indexOf(dateKey) !== -1;
    var reason = weekday === 0 || weekday === 6 ? 'weekend' : holiday ? 'holiday' : nowMs >= cutoffMs ? 'cutoff' : 'active';
    return { active: reason === 'active', reason: reason, remainingMs: reason === 'active' ? cutoffMs - nowMs : 0, cutoffMs: cutoffMs, dateKey: dateKey };
  }

  function parseClosedDates(text) {
    if (typeof text !== 'string') return null;
    var dates = text.trim() ? text.trim().split(/[\s,]+/).filter(Boolean) : [];
    return dates.every(isDateKey) ? dates : null;
  }

  function validDateHeader(value) {
    if (typeof value !== 'string' || !/^(Sun|Mon|Tue|Wed|Thu|Fri|Sat), \d{2} (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{4} \d{2}:\d{2}:\d{2} GMT$/.test(value)) return NaN;
    var epoch = Date.parse(value);
    if (!finite(epoch) || epoch < Date.UTC(2000, 0, 1) || epoch >= Date.UTC(2101, 0, 1)) return NaN;
    return new Date(epoch).toUTCString() === value ? epoch : NaN;
  }
  function eligibleContentType(value) {
    return typeof value === 'string' && /^(application\/json|text\/javascript|application\/javascript)(?:\s*;|$)/i.test(value.trim());
  }
  function getServerAnchor(input) {
    if (!input || input.status !== 200 || input.redirected || !finite(input.rttMs) || input.rttMs < 0 || input.rttMs > 1500 || !finite(input.receivedPerfMs) || !finite(input.receivedWallMs)) return null;
    var epoch = validDateHeader(input.dateHeader);
    if (!finite(epoch) || !eligibleContentType(input.contentType)) return null;
    try { if (new URL(input.url).origin !== new URL(input.origin).origin) return null; } catch (_) { return null; }
    if (input.ageHeader !== undefined && input.ageHeader !== null && !/^\s*0\s*$/.test(String(input.ageHeader))) return null;
    if (input.cacheStatus !== undefined && input.cacheStatus !== null && input.cacheStatus !== '' && ['DYNAMIC', 'BYPASS', 'MISS'].indexOf(String(input.cacheStatus).toUpperCase()) === -1) return null;
    return { epochMs: epoch + 1000 + input.rttMs, perfMs: input.receivedPerfMs, wallMs: input.receivedWallMs };
  }

  function readClock(anchor, perfMs, wallMs, options) {
    options = options || {};
    var ttlMs = options.ttlMs === undefined ? 60000 : options.ttlMs;
    var maxDriftMs = options.maxDriftMs === undefined ? 2000 : options.maxDriftMs;
    if (!anchor || !finite(anchor.epochMs) || !finite(anchor.perfMs) || !finite(anchor.wallMs) || !finite(perfMs) || !finite(wallMs) || !finite(ttlMs) || !finite(maxDriftMs) || ttlMs < 0 || maxDriftMs < 0) return NaN;
    var elapsed = perfMs - anchor.perfMs;
    var wallElapsed = wallMs - anchor.wallMs;
    if (elapsed < 0 || elapsed > ttlMs || Math.abs(wallElapsed - elapsed) > maxDriftMs) return NaN;
    return anchor.epochMs + elapsed;
  }

  return { getWindow: getWindow, parseClosedDates: parseClosedDates, getServerAnchor: getServerAnchor, readClock: readClock };
}));
